import axios from 'axios';
import { AffilieEmployers, CotisationsStats } from 'core/models';

export function getAffiliesEmployers(risk: string) {
    return axios.get<AffilieEmployers[]>(`/stats/affilies_employers?risk=` + risk).then((res: any) => {
        return res;
    });
}

export function getBias() {}

export function getCotisations() {
    return axios.get<CotisationsStats>('/stats/cotisations').then((res: any) => {
        return res.data;
    });
}
